import { type Inventory, type SetEquippedProps, type InventoryDispatchProps, type SetQuantityProps, type ResetQuantityProps} from 'src/types'
import { defaultInventory } from './defaults'

const setQuantity = (inventory: Inventory, { itemID, storage, quantity }: SetQuantityProps) => {
  const key = Object.keys(quantity)[0]

  // this checks if the value is sourced directly or from an existing variable

  // @ts-expect-error
  const value = quantity[key]

  const count: number = typeof value === 'number' ? value : Number(value) ? Number(value) : inventory.bag[value] || 0

  return {
    ...inventory,
    [storage]: {
      ...inventory[storage],
      [itemID]: (
        key === '='
          ? count
          : key === '+'
            ? (inventory[storage][itemID] || 0) + count
            : key === '-' && (inventory[storage][itemID] || 0) - count < 0 && itemID !== 'karma'
              ? 0
              : key === '-'
                ? (inventory[storage][itemID] || 0) - count
                : inventory[storage][itemID]
      )
    }
  }
}

const resetQuantity = (inventory: Inventory, { storage }: ResetQuantityProps) => (
  {
    ...inventory,
    [storage]: {}
  }
)

const setEquipped = (inventory: Inventory, { slot, itemID, equipped }: SetEquippedProps) => (
  {
    ...inventory,
    equipped: {
      ...inventory.equipped,
      [slot]: equipped ? itemID : ''
    }
  }
)

const removeAllEquipment = (inventory: Inventory) => (
  {
    ...inventory,
    equipped: defaultInventory.equipped
  }
)

export const reducer = (inventory: Inventory, action: InventoryDispatchProps) => {
  switch (action.type) {
    case 'SET_QUANTITY':
      return setQuantity(inventory, action)
    case 'RESET_QUANTITY':
      return resetQuantity(inventory, action)
    case 'SET_EQUIPMENT':
      return setEquipped(inventory, action)
    case 'REMOVE_ALL_EQUIPMENT':
      return removeAllEquipment(inventory)
    default:
      return inventory
  }
}
